import { Component, OnInit } from '@angular/core';
import { CompaniesService } from 'src/app/services/companies.service';

@Component({
  selector: 'aw-execute-list',
  templateUrl: './execute-list.component.html',
  styleUrls: ['./execute-list.component.scss']
})
export class ExecuteListComponent implements OnInit {
  
  loading: boolean;
  dataSource: any[];
  displayedColumns = ['title', 'testbed', 'actions'];
  displayedColumnsBoxes = ['name']
  expandedBoxes: any;

  constructor(
    private companiesService: CompaniesService
  ) {}

  ngOnInit(): void {

    this.loading = true;
    this.companiesService.getExecutionList().subscribe(response => {
      console.log(response);
      this.dataSource = response.data;
      this.loading = false;
    })
  }

  expandBoxes(element: any): void {

    this.expandedBoxes != element ?
      this.expandedBoxes = element :
      this.expandedBoxes = undefined;

  
  }

}
